import React, { Component } from 'react';
import { Auth } from 'aws-amplify';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import environment from '../environments';

const styles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    fullWidth: true,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  }
});

class Terms extends Component {
  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];
  }

  componentDidMount() {
    this.props.termsStore.getCurrentTerms();
  }

  handleSignOut() {
    Auth.signOut();
  }

  handleAcceptCurrentTerms() {
    this.props.termsStore.acceptCurrentTerms();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="stretch">
          <Grid item xs={12} style={{height: "65vh"}}>
            <iframe src={environment.API_HOST + "/terms/html?lang=de"} width="100%" height="100%" title="Datenschutzerklärung und Nutzungsbedingungen" style={{overflow:"hidden", border: 0, display: "block"}}></iframe>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="secondary" onClick={this.handleAcceptCurrentTerms.bind(this)} fullWidth className={classes.button}>
              Akzeptieren
            </Button>
            <Button color="secondary" fullWidth onClick={this.handleSignOut.bind(this)} className={classes.button}>
                Ablehnen
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(observer(Terms));